import { NewsIcon, Typography } from 'components'

const TrendingCard = () => (
	<a
		aria-label='Go to AI blog post'
		class='hover:background-transparent flex cursor-pointer rounded-md border border-black-800 bg-gradient-to-r from-black-800 to-black-900 p-5 transition-all hover:bg-black-850 hover:from-transparent hover:to-transparent'
		href='https://blog.codigo.ai/can-generic-ai-models-like-chatgpt-gemini-and-claude-code-for-solana-a-deep-dive-into-current-web3-ai-x-coding-capabilities/'
		rel='noopener noreferrer'
		style={{
			background: 'linear-gradient(90deg, #323437 -16.84%, #151515 23.32%)'
		}}
		target='_blank'
	>
		<div class='mr-5'>
			<NewsIcon className='h-5 w-5 text-black-200' />
		</div>

		<div>
			<Typography
				color='text-black-100'
				text='Can Generic AI Models Like ChatGPT, Gemini, and Claude Code for Solana? A Deep Dive into current Web3 AI x Coding capabilities.'
				variant='text2'
			/>
			<div class='mt-4 flex space-x-4 text-sm text-gray-400'>
				<Typography
					class='inline-block'
					color='text-black-200'
					text='Post'
					variant='text3'
				/>
			</div>
		</div>
	</a>
)

export { TrendingCard }
